import { useProgress } from "@react-three/drei";
import React from "react";
import styles from "./LoadingScreen.module.scss";

const LoadingScreen = React.memo(() => {
  const { progress } = useProgress();

  return (
    <div className={styles.loadingScreen} role="status" aria-label="Loading portfolio">
      <div className={styles.loadingContainer} role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100}>
        <div className={styles.progressCircle}>
          <svg className={styles.progressRing} width="120" height="120">
            <circle
              className={styles.progressRingCircleBg}
              strokeWidth="4"
              fill="transparent"
              r="52"
              cx="60"
              cy="60"
            />
            <circle
              className={styles.progressRingCircle}
              strokeWidth="4"
              fill="transparent"
              r="52"
              cx="60"
              cy="60"
              style={{
                strokeDasharray: `${2 * Math.PI * 52}`,
                strokeDashoffset: `${2 * Math.PI * 52 * (1 - progress / 100)}`,
              }}
            />
          </svg>
          <div className={styles.progressText}>{Math.round(progress)}%</div>
        </div>
      </div>
    </div>
  );
});

export default LoadingScreen;
